export default "__VITE_ASSET__CErPVrYp__"